import React from "react";
import { BUILD_PATH } from "../../constants/app.constants";
import { Link } from "react-router-dom";

interface TabProps {
  label: string;
  path: string;
  onClick: () => void;
  isActive: boolean;
}

const Tab: React.FC<TabProps> = ({ label, path, onClick, isActive }) => (
  <li className="nav-item">
    <Link
      to={`/${BUILD_PATH}${path}`}
      className={`nav-link ${isActive && "active"} d-flex align-items-center justify-content-center`}
      onClick={onClick}
    >
      <span className={`tab_${path.toLowerCase()}`} />
      <span>{label}</span>
    </Link>
  </li>
);

export default Tab;
